var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('junk-it-header'),_c('toronto-pricing',{attrs:{"step":3}}),_c('payment'),_c('clients-reviews'),_c('questions'),_c('div',{staticStyle:{"flex-grow":"1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }